<template>
    <div class="content work_wrapper search_content analysis simple_content">
        <v-row class="search_box">
            <v-col>
            <searchBar></searchBar>
            </v-col>
        </v-row>
        <div class="analy_index_center">
            <div class="flex_style betw  mart24">
                <div class="md_title marl32">数据分析</div>
            </div>
            <v-row class="tabs_wrapper grey_tabs analy_center">
                <v-col sm="12" md="12">
                    <v-tabs v-model="activeKey">
                        <v-tab key="1">保存的分析项目</v-tab>
                        <v-tab key="2">历史语句</v-tab>
                        <v-tab-item key="1">
                            <div class="tab_content">
                                <v-row>
                                    <v-col sm="24">
                                        <div class="list_content_wrapper">
                                            <div class="filter_top_wrapper">
                                                <div :class="{'search_input_content': true,'active': active}" v-if="false">
                                                    <div class="search_inputs">
                                                        <v-text-field
                                                            outlined
                                                            v-model="filterKey"
                                                            :dense="true"
                                                            hide-details
                                                            placeholder="搜索保存的分析项目"
                                                            clearable
                                                            @focus="active = true"
                                                            @blur="active = false"
                                                        ></v-text-field>
                                                    </div>
                                                    <span class="search_btn"><i class="icon"></i></span>
                                                </div>
                                                <div class="search_content_show">
                                                    <i class="icon table" v-if="!proTable" @click="proTable=true"></i>
                                                    <i class="icon card" v-else @click="proTable=false"></i>
                                                </div>
                                            </div>
                                            <div class="list_wrapper clearfix" v-if="!proTable">
                                                <!-- <div class="item">
                                                    <div class="img"></div>
                                                    <div class="tit_wrapper">
                                                        <div class="title"><router-link :to="{path: '/analyse/classify/272',query: {'str': '华为手机','currentName': '华为手机','spc': 'project'}}" target="_blank">示例项目： 华为手机</router-link></div>
                                                        <div class="more_btn">
                                                            <v-icon>mdi-dots-horizontal</v-icon>
                                                            <div class="pop_center_wrapper">
                                                                <div class="list_item edit">
                                                                    <span class="icon"></span>
                                                                    <span class="text" @click="editProjt(272)">编辑</span>
                                                                </div>
                                                                <div class="list_item del">
                                                                    <span class="icon"></span>
                                                                    <span class="text">删除</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="tit_wrapper">
                                                        <div class="desc">2021-01-01 14:00:00</div>
                                                        <div class="desc">2021条专利</div>
                                                    </div>
                                                </div> -->
                                                <div class="item" v-for="item in list1" :key="item.id">
                                                    <div :class="'img icon'+ item.cover "></div>
                                                    <div class="tit_wrapper">
                                                        <div class="title" >
                                                            <!-- <a href="">{{item.rationName}}</a> -->
                                                            <router-link :to="{path: '/analyse/classify/'+ item.id,query: {'str': item.keywords,'currentName': item.rationName,'status': item.status,'cover': item.cover,'spc': 'project'}}" target="_blank">{{item.rationName}}</router-link>
                                                        </div>
                                                        <div class="more_btn">
                                                            <v-icon>mdi-dots-horizontal</v-icon>
                                                            <div class="pop_center_wrapper">
                                                                <div class="list_item edit">
                                                                    <span class="icon"></span>
                                                                    <span class="text" @click="editProjt(item)">编辑</span>
                                                                </div>
                                                                <div class="list_item del" @click="delProject(item.id)">
                                                                    <span class="icon"></span>
                                                                    <span class="text">删除</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="tit_wrapper">
                                                        <div class="desc">{{timeFormat(item.createdAt)}}</div>
                                                        <div class="desc" v-if="item.num">{{item.num}}条专利</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="hist_wrapper" v-if="proTable">
                                                <v-data-table
                                                    item-key="id"
                                                    :headers="headers1"
                                                    :items="list1"
                                                    disable-pagination
                                                    hide-default-footer
                                                    class="common_table"
                                                >
                                                    <template v-slot:item.createdAt="{item}">
                                                        <div>
                                                            <span>{{timeFormat(item.createdAt)}}</span>
                                                        </div>
                                                    </template>
                                                    <template v-slot:item.actions="{item}">
                                                        <div class="icon_list" v-if="item">
                                                            <div class="more_btn">
                                                                <v-icon>mdi-dots-horizontal</v-icon>
                                                                <div class="pop_center_wrapper table_type">
                                                                    <div class="list_item edit">
                                                                        <span class="icon"></span>
                                                                        <span class="text" @click="editProjt(item)">编辑</span>
                                                                    </div>
                                                                    <div class="list_item del" @click="delProject(item.id)">
                                                                        <span class="icon"></span>
                                                                        <span class="text">删除</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </v-data-table>
                                            </div>
                                        </div>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-tab-item>
                        <v-tab-item key="2">
                            <div class="tab_content">
                                <div class="hist_filter_wrapper" v-if="false">
                                    <div :class="{'search_input_content': true,'active': active1}">
                                        <div class="search_inputs">
                                            <v-text-field
                                                outlined
                                                v-model="filterKey"
                                                :dense="true"
                                                hide-details
                                                placeholder="搜索历史语句"
                                                clearable
                                                @focus="active1 = true"
                                                @blur="active1 = false"
                                            ></v-text-field>
                                        </div>
                                        <span class="search_btn"><i class="icon"></i></span>
                                    </div>
                                    <div class="line_gap"></div>
                                    <div class="analy_input_style">
                                        <v-select
                                            v-model="timeRange"
                                            outlined
                                            dense
                                            hide-details
                                            item-text="value"
                                            item-value="key"
                                            :items="itemList">
                                        </v-select>
                                    </div>
                                </div>
                                <div class="multiple_btn_del" v-if="selectedItem.length>0" @click="historyItemDel(selectedItem,'list')">批量删除</div>
                                <div class="hist_wrapper">
                                    <v-data-table
                                        v-model="selectedItem"
                                        item-key="id"
                                        :headers="headers"
                                        :items="historyList"
                                        show-select
                                        disable-pagination
                                        hide-default-footer
                                        class="common_table"
                                    >
                                        <template v-slot:item="{index,headers,item,isSelected,select}">
                                            <tr>
                                            <td class="text-start"
                                                v-for="(item1,index1) in headers"
                                                :key="index1">
                                                <div class="tit_overflow" v-if="item1.value == 'data-table-select'">
                                                    <div>
                                                        <v-simple-checkbox
                                                        :value="isSelected"
                                                        @input="select($event)"
                                                        ></v-simple-checkbox>
                                                    </div>
                                                </div>
                                                <div class="tit_overflow" v-else-if="item1.value == 'index'">
                                                    {{index+1}}
                                                </div>
                                                <div class="tit_overflow" v-else-if="item1.value == 'searchFormula'">
                                                    {{item.searchFormula}}
                                                </div>
                                                <div class="tit_overflow" v-else-if="item1.value == 'createdAt'">
                                                    {{timeFormat(item.createdAt)}}
                                                </div>
                                                <div class="tit_overflow" v-else-if="item1.value == 'actions'">
                                                        <div class="icon_list" v-if="item">
                                                            <v-tooltip top>
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <div class="item ana" v-bind="attrs" v-on="on" @click="goAnalysis1(item.keywords)"><span class="icon"></span></div>
                                                                </template>
                                                                <span style="color:#fff">执行分析</span>
                                                            </v-tooltip>
                                                            <v-tooltip top>
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <div class="item del" v-bind="attrs" v-on="on" @click="historyItemDel([item.id])"><span class="icon"></span></div>
                                                                </template>
                                                                <span style="color:#fff">删除</span>
                                                            </v-tooltip>
                                                        </div>
                                                </div>
                                                <div class="hand tit_overflow" v-else>
                                                    <span>{{item[item1.value]}}</span>
                                                </div>
                                            </td>
                                            </tr>
                                        </template> 
                                        <!-- <template v-slot:item.index="{item}">
                                            <div>{{item.id}}</div>
                                        </template>
                                        <template v-slot:item.searchFormula="{item}">
                                            <div style="max-width: 200px" class="overflow1">{{item.searchFormula}}</div>
                                        </template>
                                        <template v-slot:item.createdAt="{item}">
                                            <div>
                                                <span>{{timeFormat(item.createdAt)}}</span>
                                            </div>
                                        </template>
                                        <template v-slot:item.actions="{item}">
                                            <div class="icon_list" v-if="item">
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <div class="item ana" v-bind="attrs" v-on="on" @click="goAnalysis1(item.keywords)"><span class="icon"></span></div>
                                                    </template>
                                                    <span style="color:#fff">执行分析</span>
                                                </v-tooltip>
                                                 <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <div class="item del" v-bind="attrs" v-on="on" @click="historyItemDel([item.id])"><span class="icon"></span></div>
                                                    </template>
                                                    <span style="color:#fff">删除</span>
                                                </v-tooltip>
                                            </div>
                                        </template>  -->
                                    </v-data-table>
                                </div>
                                <div class="hist_pagination">
                                    <v-row>
                                        <v-col class="common_page">
                                            <!-- <span class="text hidden-xs-only">共{{total}}条记录</span> -->
                                            <v-pagination
                                                v-model="currentPage"
                                                :length="historyList.length"
                                                :total-visible="7"
                                                >
                                            </v-pagination>
                                        </v-col>
                                    </v-row>
                                </div>
                            </div>
                        </v-tab-item>
                    </v-tabs>
                </v-col>
            </v-row>
        </div>
        <!-- 编辑弹窗 -->
        <v-dialog v-model="saveDialog" width="500">
        <v-card class="country_dialog">
            <v-card-title class="headline lighten-2">保存分析项目</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <div class="padlg">
                    <div class="common_input_style">
                        <v-text-field
                            label="名称"
                            v-model="savedInfo.name"
                            outlined
                            placeholder="请输入项目名称，不超过100个字"
                            hide-details>
                        </v-text-field>
                    </div>
                    <div class="analy_mask_item">
                    <span class="label">封面</span>
                    <span :class="'img_mask mask'+ savedInfo.cover">
                        <div class="icon" @click="maskDialog=true">更换</div>
                    </span>
                    </div>
                </div>
            </v-card-text>
            <v-divider></v-divider>

            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                @click="handleSaveCancel">
                取消
            </v-btn>
            <v-btn
                color="primary"
                @click="handleSaveOk">
                确定
            </v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>
        <v-dialog
        v-model="maskDialog"
        width="500"
        >
        <v-card class="country_dialog">
            <v-card-title class="headline lighten-2">选择封面</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <div class="padlg">
                    <div class="mask_img_wrapper">
                    <div :class="{'img_mask': true, 'mask0':true, 'active': maskIndex==0}" @click="maskIndex=0"></div>
                    <div :class="{'img_mask': true, 'mask1':true, 'active': maskIndex==1}" @click="maskIndex=1"></div>
                    <div :class="{'img_mask': true, 'mask2':true, 'active': maskIndex==2}" @click="maskIndex=2"></div>
                    <div :class="{'img_mask': true, 'mask3':true, 'active': maskIndex==3}" @click="maskIndex=3"></div>
                    </div>
                </div>
            </v-card-text>
            <v-divider></v-divider>

            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                @click="handleMaskCancel">
                取消
            </v-btn>
            <v-btn
                color="primary"
                @click="handleMaskOk">
                确定
            </v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>
    </div>
</template>
<script>
import searchBar from "@/components/side/searchBar.vue";
import {mapActions} from 'vuex'
import Qs from 'qs'
export default {
    data() {
        return {
            activeKey: 0,
            layoutRight: 10,
            collapse: false,
            text: '',
            placeholder: '支持搜索关键字、公司名、人名、专利号等',
            searchKey: '',
            keyValue: '',
            list1: [],
            historyList: [],
            selectedItem: [],
            headers: [
                {
                    text: '序号',
                    align: 'start',
                    sortable: false,
                    value: 'index'
                },
                {
                    text: '名称',
                    align: 'start',
                    sortable: false,
                    value: 'keywords'
                },
                {
                    text: '检索式',
                    align: 'start',
                    sortable: false,
                    value: 'searchFormula'
                },
                {
                    text: '检索数量',
                    align: 'start',
                    sortable: false,
                    value: 'num'
                },
                {
                    text: '创建时间',
                    align: 'start',
                    sortable: false,
                    value: 'createdAt'
                },
                {
                    text: '操作',
                    align: 'start',
                    sortable: false,
                    value: 'actions'
                },
            ],
            headers1: [
                {
                    text: '名称',
                    align: 'start',
                    sortable: false,
                    value: 'rationName'
                },
                {
                    text: '关键词',
                    align: 'start',
                    sortable: false,
                    value: 'keywords'
                },
                {
                    text: '创建时间',
                    align: 'start',
                    sortable: false,
                    value: 'createdAt'
                },
                {
                    text: '操作',
                    align: 'start',
                    sortable: false,
                    value: 'actions'
                },
            ],
            isShow: true,
            filterKey: '',
            timeRange: '7',
            itemList: [
                {
                    key: '7',
                    value: '最近一周'
                },
                {
                    key: '15',
                    value: '最近半个月'
                },
                {
                    key: '30',
                    value: '最近一个月'
                },
            ],
            saveDialog: false,
            rationName: '',
            maskIndex: 0,
            maskDialog: false,
            proTable: false,
            savedInfo: {},
            active: false,
            active1: false,
            currentPage: 1,
            pageSize: 16
        }
        
    },
    mounted() {
        this.keyValue = this.$route.query.str
        this.getProList()
        this.getHistory()
    },
    components: {
        searchBar,
    },
    watch: {
        currentPage() {
            this.getHistory()
        }
    },
    methods: {
        ...mapActions('analy',['rationList','deleteSavedPro','updateSavePro']),
        ...mapActions('search',['getHistoryList','delHistory']),
        getHistory() {
            let _this = this
            let data = {
                params: {
                    page: this.currentPage,
                    pageSize: this.pageSize
                }
            }
            this.getHistoryList({data: data,handle(res) {
                let list = res.message
                // console.log(res.message,'===res.message===')
                _this.historyList = JSON.parse(list)
            }})
        },
        getProList() {
            let data = {
                params: {
                    q: this.keyValue,
                    p: 1,
                    ps: 20
                }
            }
            let _this = this 
            this.rationList({data: data,handle(res) {
                _this.list1 = res.pagination.data
            }})

        },
        goAnalysis(id, query) {
            this.$router.push({
                path: '/analyse/classify/'+ id,
                query: query
            })
        },
        goAnalysis1(val){
            this.$router.push({
              path: '/analyse/classify/all',
              query: {
                str: val
              }
            })
        },
        timeFormat(unixTime) {
            let date = new Date(unixTime);
            let Y = date.getFullYear() + '-';
            let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            let D = date.getDate() + ' ';
            let h = date.getHours() + ':';
            let m = date.getMinutes() + ':';
            let s = date.getSeconds();
            return Y+M+D+h+m+s;
        },
        editProjt(val) {
            val.name = val.rationName
            this.savedInfo = JSON.parse(JSON.stringify(val))
            this.saveDialog = true
        },
        handleSaveCancel() {
            this.saveDialog = false
        },
        handleSaveOk() {
            this.saveDialog = false
            let data = Qs.stringify(this.savedInfo)
            let _this = this 
            this.updateSavePro({data: data,handle(res) {
                _this.$message({
                    type: 'success',
                    message: res.message
                }); 
                _this.getProList();
            }})
        },
        handleMaskCancel() {
            this.maskDialog = false
        },
        handleMaskOk() {
            this.savedInfo.cover = this.maskIndex
            this.maskDialog = false
        },
        delProject(id) {
           this.$msgbox.confirm('此操作将永久删除该项目, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let data = {
                    id: id
                }
                data = Qs.stringify(data)
                let _this = this
                this.deleteSavedPro({data: data,handle(res) {
                    if(res.success) {
                        _this.$message({
                            type: 'success',
                            message: res.message
                        }); 
                        _this.getProList() 
                    } 
                }})
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        historyItemDel(id,val) {
            if(val == 'list') {
                id = id.map((item)=>{
                    return item.id
                })
            }
            
            let ids = id.join(',')
            this.$msgbox.confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let data = {
                    params: {
                        ids: ids
                    }
                }
                let _this = this
                this.delHistory({data: data,handle(res) {
                    if(res.success) {
                        _this.$message({
                            type: 'success',
                            message: res.message || '操作成功'
                        }); 
                        _this.getHistory() 
                    } 
                }})
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        }
    }
}
</script>